import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import AngleRight from 'react-icons/lib/fa/angle-right'

import { color, mixin } from '../globalStyles'

const Card = styled(Link)`
  ${mixin.card};
  ${mixin.cardHover};
  background: white;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg {
    width: 2.5rem;
    height: 2.5rem;
  }
`
const Title = styled.h4`
  margin-bottom: 0;
`
const Subtitle = styled.div`
  margin-bottom: 0;
  font-size: 1.4rem;
  font-weight: 400;
  color: ${color.darkGrey};
`

const InfoPageCard = ({title, subtitle, to}) => (
  <Card to={to}>
    <div>
      {title && <Title>{title}</Title>}
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </div>
    <AngleRight />
  </Card>
)

InfoPageCard.propTypes = {
  to: PropTypes.string.isRequired
}

export default InfoPageCard



// WEBPACK FOOTER //
// ./src/components/InfoPageCard.js